import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { kycReferenceItem } from "./api/transformers/kyc";
import { RootState } from "app/store";
import { EntityType } from "./api/transformers/investor";
import { Marker } from "./api/transformers/marker";

export interface AmlStoreState {
  kycReferences: kycReferenceItem[];
  entityTypes: EntityType[];
  markers: Marker[];
}

const initialState: AmlStoreState = {
  kycReferences: [],
  entityTypes: [],
  markers: [],
};

export const amlSlice = createSlice({
  name: "aml",
  initialState,
  reducers: {
    setKycReferences: (state, action: PayloadAction<kycReferenceItem[]>) => {
      state.kycReferences = action.payload;
    },
    setEntityTypes: (state, action: PayloadAction<EntityType[]>) => {
      state.entityTypes = action.payload;
    },
    setMarkers: (state, action: PayloadAction<Marker[]>) => {
      state.markers = action.payload;
    }
  }
});

export const amlStoreActions = amlSlice.actions;
export function selectFromAmlStore<R>(selector: (state: AmlStoreState) => R) {
  return (state: RootState) => selector(state.amlReducer);
}
export const selectors = {
  markers: selectFromAmlStore((state) => state.markers)
};
export default amlSlice.reducer;
